<script>
    import Route, {router} from "../lib/Router/Router.svelte"
    import R, {LOADER} from "../lib/requests";
    import members from "../stores/members";
    import app from "../stores/app";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true},
        {key: 'lastname', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'phone', title: 'ΤΗΛΕΦΩΝΟ', sortable: false, class: 'hidden-xs'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'afm', title: 'ΑΦΜ', sortable: true, class: 'hidden-xs'},
        {key: 'region_id', title: 'ΝΟΜΟΣ', sortable: true, class: 'hidden-xs'},
        {key: 'city', title: 'ΠΟΛΗ', sortable: true, class: 'hidden-xs'},
        {key: 'expires_at', title: 'ΣΥΝΔΡ.', sortable: true, class: 'hidden-xs'},
        {key: 'activated_at', title: 'ΕΝΕΡΓΟΠ.', sortable: true, class: 'hidden-xs'},
        {key: 'login_at', title: 'ΕΙΣΟΔΟΣ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let pageHeaderControls = [
        {id: 'merge', name: 'ΕΝΟΠΟΙΗΣΗ', hidden: true},
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΜΕΛΟΥΣ', link: '/app/new-member', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            link: '/app/new-member',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let showMerge = false;

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            $members.list = result.list;
            $members.total = ~~result.total;

            $members.list.map(item => {
                if (!item.code) {
                    item.code = '';
                }
                if (!item.phone1) {
                    item.phone1 = '';
                }
                if (!item.last_subscription) {
                    item.last_subscription = '';
                }
            });

            if ($members.search.code && $members.list.length == 2) {
                showMerge = $members.list[0].code === $members.list[1].code;
            }
            setControls();
        }

        const onFailure = err => {
        };

        showMerge = false;
        setControls();
        $members.search.offset = ($members.page - 1) * $members.search.limit;

        R.handle(R.member.index, $members.search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        $members.page = 1;
        load();
    }

    const clearSearch = () => {
        members.clearSearch();
        $members.page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        $members.search.sort_field = detail.key;
        $members.search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        $members.page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const onEdit = (member) => {
        $members.selectedId = member.id;
        $members.scrollY = window.scrollY;
        router.go(`/app/member/${member.id}`)();
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή μέλους", `Πρόκειται να διαγράψετε το μέλος "${item.name}".\nΘέλετε να συνεχίσετε;`, () => deleteMember(item.id));
    }

    const deleteMember = id => {
        const onSuccess = result => {
            $members.list = $members.list.filter(x => x.id != result);
            Notifier.showMessage("Το μέλος διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code) {
                if (err.code === 'object_related') {
                    let prompt = '';
                    if (err.params.orders) {
                        prompt = `Το μέλος που θέλετε να διαγράψετε είναι συσχετισμένο με ${err.params.orders} παραγγελίες.`;
                    } else if (err.params.passports) {
                        prompt = `Το μέλος που θέλετε να διαγράψετε είναι συσχετισμένο με ${err.params.passports} διαβατήρια.`;
                    }
                    Alert.warning("Διαγραφή μέλους", prompt + "\nΗ διαγραφή του μέλους δεν είναι δυνατή!");
                }
            }
        };

        R.handle(R.member.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const initialize = () => {
        if (!$members.list) {
            $members.page = 1;
            $members.search.limit = itemsPerPage[0];

            load(LOADER.PAGE);
        } else if ($members.changed) {
            // order data changed from OrderEdit component
            load(LOADER.NONE);
            $members.changed = false;
        }

        if ($members.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $members.scrollY});
                $members.scrollY = null;
            }, 50);

        }
    }

    const setControls = () => {
        // set merge
        let item = pageHeaderControls.find(x => x.id === 'merge');
        item.hidden = !showMerge;
        // set creation according to user role
        let items = pageHeaderControls.filter(x => x.id === 'create');
        items.map(item => {
            item.hidden = !user.isAdmin();
        })
        pageHeaderControls = pageHeaderControls;
    }

    const onMerge = () => {
        Alert.confirm("Ενοποίηση στοιχείων", `Να ενοποιηθούν τα στοιχεία των μελών με κωδικό ${$members.list[0].code};`, () => merge());
    }

    const merge = () => {
        const onSuccess = result => {
            load();
        }

        const onFailure = err => {
            Alert.warning("Ενοποίηση στοιχείων μέλους", "Δεν βρέθηκε το μέλος με διπλά στοιχεία!");
        };

        let data = $members.list.map(item => (item.id));
        R.handle(R.member.merge, data, onSuccess, onFailure, LOADER.POPUP);


    }

    initialize();
</script>

<PageHeader title="Μέλη" controls={ pageHeaderControls } on:reload={ load } on:merge={ onMerge }/>
<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 form-group-sm">
            <select class="form-select" bind:value="{ $members.search.status }" on:change={ onSearch }>
                <option value="">Όλα τα μέλη</option>
                <option value="1">Ενεργά</option>
                <option value="2">Ανενεργά</option>
                <option value="3">Μη επαληθευμένα</option>
            </select>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.code }" on:change={ onSearch }
                   placeholder="αρ. μητρώου">
        </div>
        <div class="col-xl-1 col-lg-2 col-md-7 form-group-lg form-group-md form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.afm }" on:change={ onSearch }
                   placeholder="Α.Φ.Μ.">
        </div>
        <div class="col-xl-2 col-lg-6 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.name }" on:change={ onSearch }
                   placeholder="όνομα">
        </div>
        <div class="col-xl-2 col-lg-8 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ $members.search.term }" on:change={ onSearch }
                   placeholder="τηλέφωνο ή email">
        </div>
        <div class="col-xl-2 col-lg-8 col-md-4 form-group-sm">
            <select class="form-select" bind:value="{ $members.search.region_id }">
                <option value="">νομός</option>
                {#each $app.regions as region}
                    <option value="{ region.id }">{ region.name }</option>
                {/each}
            </select>
            <!--            <input type="text" class="form-control" bind:value="{ $members.search.city }" on:change={ onSearch }-->
            <!--                   placeholder="πόλη">-->
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ $members.search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    {#if $members.list && $members.list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Μέλη: <strong>{ $members.total }</strong></span>
            <span class="listing-info hidden-xs">Σελίδα: <strong>{ $members.page }</strong></span>
        </div>
    {/if}
</div>

{#if $members.list}
    {#if $members.list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each $members.list as item}
                <tr class="row-hover" class:row-selected="{ $members.selectedId === item.id }">
                    <td class="code">
                        { item.code }
                    </td>
                    <td>
                        <span class="is-link" class:not-active="{ item.status_id == 2 }"
                              class:not-verified={ item.is_verified == 0}
                              on:click="{ () => onEdit(item) }">
                            { item.name }
                        </span>
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.phone1 }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.afm }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.region_name }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.city }
                    </td>
                    <td class="year-column text-gray text-center hidden-xs">
                        { formatDate(item.expires_at, 'y') }
                    </td>
                    <td class="year-column text-gray hidden-xs">
                        { formatDate(item.activated_at, 'd-m-y') }
                    </td>
                    <td class="date-column text-gray hidden-xs">
                        { formatDate(item.login_at, 'd-m-y') }
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column pointer" title="διαγραφή μέλους"
                            on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ $members.search.limit }" totalItems="{ $members.total }" page="{ $members.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            Δεν βρέθηκαν μέλη.
        </div>
    {/if}
{/if}


<style>
    .members-list .code {
        width: 60px;
    }

    .members-list .not-verified {
        color: #777;
    }
</style>